import React from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';

const RemoveWall = ({
  actionTriggeredCallback,
}: {
  actionTriggeredCallback: () => void;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);

  const onRemove = () => {
    window.DeleteWallLineAndConnection();
    actionTriggeredCallback();
  };

  return (
    <PrimaryButton className="action-button" onClick={onRemove}>
      {t(`${translations.common}:Remove`).toLocaleUpperCase()}
    </PrimaryButton>
  );
};

export default RemoveWall;
